import { FC } from 'react';
import { MoonLoader } from 'react-spinners';
import { Modal } from './Modal.client';

interface Props {
  loading: boolean;
  onClose?: () => void;
}

export const LoadingModal: FC<Props> = ({ loading, onClose = () => {} }) => (
  <Modal open={loading} onClose={onClose}>
    <div className="flex justify-center items-center w-full h-full">
      <MoonLoader />
    </div>
  </Modal>
);
